import { render, staticRenderFns } from "./teachers.vue?vue&type=template&id=d7503344&"
import script from "./teachers.vue?vue&type=script&lang=js&"
export * from "./teachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports